/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./login-logo.component";
var styles_LoginLogoComponent = ["[_nghost-%COMP%] {\n        display: flex;\n        justify-content: center;\n      }\n      img[_ngcontent-%COMP%] {\n        height: 45px;\n        margin: 32px 0;\n      }"];
var RenderType_LoginLogoComponent = i0.ɵcrt({ encapsulation: 0, styles: styles_LoginLogoComponent, data: {} });
export { RenderType_LoginLogoComponent as RenderType_LoginLogoComponent };
export function View_LoginLogoComponent_0(_l) { return i0.ɵvid(2, [(_l()(), i0.ɵeld(0, 0, null, null, 0, "img", [["alt", "OpenEnglish"], ["draggable", "false"], ["src", "/images/logo_black_lg.png"]], null, null, null, null, null))], null, null); }
export function View_LoginLogoComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "lp2-login-logo", [], null, null, null, View_LoginLogoComponent_0, RenderType_LoginLogoComponent)), i0.ɵdid(1, 49152, null, 0, i1.LoginLogoComponent, [], null, null)], null, null); }
var LoginLogoComponentNgFactory = i0.ɵccf("lp2-login-logo", i1.LoginLogoComponent, View_LoginLogoComponent_Host_0, {}, {}, []);
export { LoginLogoComponentNgFactory as LoginLogoComponentNgFactory };
//# sourceMappingURL=login-logo.component.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/header/login-logo/login-logo.component.ngfactory.js
// module id = 1566
// module chunks = 26 27 28